import { render, staticRenderFns } from "./PackagingUnits.vue?vue&type=template&id=ba2447ec"
import script from "./PackagingUnits.vue?vue&type=script&lang=js"
export * from "./PackagingUnits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports